import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { accountDataSelector, selectAllBalances } from '~/components/account/ducks/index.js';
import _HeaderBalance from './balance.js';
import currencyFormatter from '../../libs/currency-formatter.js';
import getLocale from '../../libs/locale.js';
import { WeSpinBalance } from '../we-spin/new-flow/index.js';
import { selectBrand, selectHasProducts } from '../brand/ducks/selectors.js';
import { Box } from '@comeon/ui';
import { HeaderIconWithEffect } from './right-container-header-buttons.js';
import Icon, { ICON_USER_SECRET, ICON_USER_LINE } from '~/components/icon';
import NotificationsNotifier from './notifications-notifier.js';

const AccountMenuLink = ({ isGuestPlayer }) => (
	<Box>
		<HeaderIconWithEffect data-at="account-icon-header" className="account-icon-header">
			{isGuestPlayer ? <Icon type={ICON_USER_SECRET} /> : <Icon type={ICON_USER_LINE} />}
		</HeaderIconWithEffect>
	</Box>
);

const UserDetails = ({ isInGame }) => {
	const locale = getLocale();
	const account = useSelector(accountDataSelector);
	const { totalBalance, casinoBalance, sportsbookBalance } = useSelector(selectAllBalances);
	const { isGuestPlayer, isDanishFranchise, isShopEnabled } = useSelector(selectBrand);

	const { hasWeSpin } = useSelector(selectHasProducts);

	const formattedBalances = useMemo(
		() => ({
			totalBalance: currencyFormatter.format(totalBalance, account.currency, locale),
			casinoBalance: currencyFormatter.format(casinoBalance, account.currency, locale),
			sportsbookBalance: currencyFormatter.format(sportsbookBalance, account.currency, locale)
		}),
		[account.currency, locale, totalBalance, casinoBalance, sportsbookBalance]
	);

	const BalanceSection = useMemo(() => (hasWeSpin ? WeSpinBalance : _HeaderBalance), [hasWeSpin]);
	const inGameView = isInGame === 'true';
	return (
		<>
			<BalanceSection
				balances={formattedBalances}
				bonusPoints={account.points}
				hydrated={account.hydrated}
				isDanishFranchise={isDanishFranchise}
				isShopEnabled={isShopEnabled}
				isInGame={isInGame}
				dataAtBalance="header-balance-info"
			/>
			<AccountMenuLink isGuestPlayer={isGuestPlayer} />
			<NotificationsNotifier isInGame={inGameView} />
		</>
	);
};

export default UserDetails;
